var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{attrs:{"elevation":_vm.hover ? 6 : 0,"open-delay":"200"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticClass:"my-3",attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }